// https://stackoverflow.com/a/36822046
const formatAMPM = (date) =>
  date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

const getCompleteDate = (date) => {
  if (!date instanceof Date) {
    return "";
  }
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    months[date.getMonth()] +
    " " +
    date.getDate() +
    ", " +
    date.getFullYear() +
    " at " +
    formatAMPM(date)
  );
};

// https://stackoverflow.com/a/10589791
const isDate = (date) => date instanceof Date && !isNaN(date.valueOf());

// https://stackoverflow.com/a/16080438
const isDateInRange = (date, fromDate, toDate) => {
  if (!isDate(date) || !isDate(fromDate) || !isDate(toDate)) {
    return false;
  }

  return (
    date.getTime() >= fromDate.getTime() && date.getTime() <= toDate.getTime()
  );
};

const countDown = (target, splitted) => {
  if (isNaN(parseInt(target)) || target === 0) {
    return {
      second: "0",
      minute: "0",
      hour: "0",
      day: "0",
    };
  }
  const cuur_time = new Date().getTime();
  const left_time = target - cuur_time;

  if (left_time <= 0) {
    return {
      second: "0",
      minute: "0",
      hour: "0",
      day: "0",
    };
  }

  let day = Math.floor(left_time / (1000 * 60 * 60 * 24)).toString();
  let hour = Math.floor(
    (left_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  ).toString();
  let minute = Math.floor(
    (left_time % (1000 * 60 * 60)) / (1000 * 60)
  ).toString();
  let second = Math.floor((left_time % (1000 * 60)) / 1000).toString();

  if (splitted) {
    day = day.split("");
    hour = hour.split("");
    minute = minute.split("");
    second = second.split("");
  }

  return {
    second,
    minute,
    hour,
    day,
  };
};

// https://stackoverflow.com/a/55987414
const formatCash = (number) => {
  if (number < 1e3) return number;
  if (number >= 1e3 && number < 1e6) return +(number / 1e3).toFixed(1) + "K";
  if (number >= 1e6 && number < 1e9) return +(number / 1e6).toFixed(1) + "M";
  if (number >= 1e9 && number < 1e12) return +(number / 1e9).toFixed(1) + "B";
  if (number >= 1e12) return +(number / 1e12).toFixed(1) + "T";
};

export const DEFAULT_ERROR_MESSAGE =
  "An unexpected error has occurred. Please check the transaction status. If it has failed, try again";

export { getCompleteDate, isDate, isDateInRange, countDown, formatCash };
